import React, { useEffect, useState } from 'react';
import { useAccount } from 'wagmi';

import { availablePositions } from 'const';
import { PromptConnectWallet, PromptWrongNetMetamask } from 'utils/MetamaskSuite';
import { useGameDetails, useIsWantedChainActive, useNextRound, useUserBetForRoundID } from 'utils/Hooks';
import CardNextBetting from './Betting';
import CardNextOverview from './Overview/overview';
import { RoundNotLoadedYet } from 'components/CardBase';
import './styles.scss';


function CardNext(props) {
  const gameDetails = useGameDetails();
  const isWantedChainActive = useIsWantedChainActive();
  const round = useNextRound();
  const userBetData = useUserBetForRoundID(round.epoch);

  const account = useAccount();

  const [roundAlreadyExpired, SetWhetherRoundExpired] = useState(false);
  const [alreadyEntered, SetWhetherRoundAlreadyEntered] = useState(false);
  const [bettingInProgress, SetBettingInProgress] = useState(false);
  const [bettingOnBear, SetWhetherBettingOnBear] = useState(false);


  useEffect(() => {
    HandleRoundExpiration();
  }, [round]);

  useEffect(() => {
    if (roundAlreadyExpired)
      SetBettingInProgress(false);
  }, [roundAlreadyExpired]);

  useEffect(() => {
    if (bettingInProgress && alreadyEntered)
      CancelBet();
  }, [bettingInProgress, alreadyEntered]);

  useEffect(() => {
    const userAlreadyBetOnThisRound = (userBetData?.amount > 0);
    SetWhetherRoundAlreadyEntered(userAlreadyBetOnThisRound);
  }, [userBetData]);


  function HandleRoundExpiration() {
    if (RoundNotLoadedYet(round))
      return;
    const lockTimestampMilliseconds = round.lockTimestamp * 1000;
    if (lockTimestampMilliseconds < Date.now())
      SetWhetherRoundExpired(true);
    else
      SetWhetherRoundExpired(false);
  }

  function GetSideUserBetOn() {
    if (!alreadyEntered) return -1;
    const userPosition = Number(userBetData.position);
    if (userPosition === availablePositions.bull) return availablePositions.bull;
    else if (userPosition === availablePositions.bear) return availablePositions.bear;
    else return -1;
  }

  function BetBear() {
    if (BetConditionsSatisfied()) {
      SetBettingInProgress(true);
      SetWhetherBettingOnBear(true);
    }
  }

  function BetBull() {
    if (BetConditionsSatisfied()) {
      SetBettingInProgress(true);
      SetWhetherBettingOnBear(false);
    }
  }

  function BetConditionsSatisfied() {
    if (RoundNotLoadedYet(round))
      return false;
    else if (!account?.address) PromptConnectWallet();
    else if (!isWantedChainActive) PromptWrongNetMetamask(gameDetails.wantedChain);
    else if (alreadyEntered) alert('You already bet this round!');
    else
      return true;
    return false;
  }


  function ToggleSelectedSide() {
    SetWhetherBettingOnBear(!bettingOnBear);
  }

  function CancelBet() {
    SetBettingInProgress(false);
    //SetWhetherBettingOnBear(false);
  }

  /*
  ExecutionNotice() {
    if (RoundExpired())
      return (
        <div>
          <h3 className='text-white'>Executing...</h3>
        </div>
      );
    else return null;
  }
  */

  if (bettingInProgress && !!account?.address) {
    return (
      <CardNextBetting
        bettingOnBear={bettingOnBear}
        CancelBet={CancelBet}
        ToggleBet={ToggleSelectedSide}
      />
    );
  } else {
    return (
      <CardNextOverview
        alreadyEntered={alreadyEntered}
        enteredPosition={GetSideUserBetOn()}
        expired={roundAlreadyExpired}
        BetBull={BetBull}
        BetBear={BetBear}
      />
    );
  }
}

export default CardNext;
